interface Key {
  [key: string]: string;
}

export const LAXATIVE_UNIT_JA: Key = {
  tablet: '錠',
  drop: '滴',
  ml: 'ml',
  pack: '包',
  piece: '個',
  unknown: 'その他・不明',
};

export const LAXATIVE_UNIT_EN: Key = {
  tablet: 'Tablets',
  drop: 'Drops',
  ml: 'ml',
  pack: 'Packets',
  piece: 'Pcs',
  unknown: 'Other/Unknown',
};

// プルダウンリスト用
export const LAXATIVE_UNIT_LIST = ['tablet', 'drop', 'ml', 'pack', 'piece', 'unknown'];

export const LAXATIVE_TYPE_JA: Key = {
  nonStimulant: '非刺激性下剤',
  stimulant: '刺激性下剤',
  enema: '浣腸',
  suppository: '坐薬',
  unknown: 'その他・不明',
};

export const LAXATIVE_TYPE_EN: Key = {
  nonStimulant: 'Non-stimulant laxatives',
  stimulant: 'Stimulant laxatives',
  enema: 'Enema',
  suppository: 'Suppositories',
  unknown: 'Other/Unknown',
};

// プルダウンリスト用
export const LAXATIVE_TYPE_LIST = ['nonStimulant', 'stimulant', 'enema', 'suppository', 'unknown'];
